<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.手机号')" prop="mobile">
                <a-input v-model="queryParam.mobile"  @pressEnter="handleQuery":placeholder="$t('通用.输入.请输入')+$t('用户.手机号')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('ID/邀请码')" prop="invitationCode">
                <a-input v-model="queryParam.invitationCode" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('ID/邀请码')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.昵称')" prop="nickName">
                <a-input v-model="queryParam.nickName" @pressEnter="handleQuery" :placeholder="$t('通用.输入.请输入')+$t('用户.昵称')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.注册时间')">
                <a-range-picker v-model="dateRange" :placeholder="['开始时间', '结束时间']" style="width: 100%"
                                valueFormat="YYYY-MM-DD HH:mm:ss" @change="onDateChange"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.性别')" prop="sex">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.性别')" v-model="queryParam.sex" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.SexEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户角色')" prop="userRole">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户角色')" v-model="queryParam.userRole" style="width: 100%" allow-clear>
<!--                  <a-select-option :value="40">{{$t('用户角色类型.店员')}}</a-select-option>-->
                  <a-select-option :value="50">{{$t('会员')}}</a-select-option>
                  <a-select-option :value="60">{{$t('班长')}}</a-select-option>
                  <a-select-option :value="70">{{$t('课代表')}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('用户.用户状态')" prop="status">
                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户状态')" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.TFEnum" :key="index" :value="d.value">{{ d.label }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>-->
<!--            <a-col :md="6" :sm="24">-->
<!--              <a-form-item :label="$t('用户.用户等级')" prop="status">-->
<!--                <a-select :placeholder="$t('通用.输入.请选择')+$t('用户.用户等级')" v-model="queryParam.levelId" style="width: 100%" allow-clear>-->
<!--                  <a-select-option v-for="(d, index) in levelList" :key="index" :value="d.id">{{ d.levelName }}</a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['user:user:add']">
          <a-icon type="plus" />{{$t('通用.按钮.新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['user:user:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleBatchSetDistributorAssistant" v-hasPermi="['biz:user:edit']">
          <a-icon type="team" />批量设置班长
        </a-button>
        <a-button type="primary" :disabled="multiple" @click="handleBatchSetSuperiorDistributor" v-hasPermi="['biz:user:edit']">
          <a-icon type="team" />批量设置上级课代表
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['user:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>
        <a-button type="primary" :disabled="multiple"  @click="handleSelectExport" v-hasPermi="['biz:user:export']">
          <a-icon type="download" />{{$t('通用.按钮.选中导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>

      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >


        <span slot="userRole" slot-scope="text, record">
           <span v-if="record.userRole == '10'">
             {{$t('用户角色类型.平台')}}
           </span>
           <span v-if="record.userRole == '20'">
             {{$t('用户角色类型.商户')}}
           </span>
           <span v-if="record.userRole == '30'">
             {{$t('用户角色类型.店长')}}
           </span>
            <span v-if="record.userRole == '40'">
             {{$t('用户角色类型.店员')}}
           </span>
           <span v-if="record.userRole == '50'">
             {{$t('会员')}}
           </span>
           <span v-if="record.userRole == '60'">
             {{$t('班长')}}
           </span>
           <span v-if="record.userRole == '70'">
             {{$t('课代表')}}
           </span>
        </span>




        <span slot="sex" slot-scope="text, record">
            <!-- 重写自定义了个字典组件-->
           <custom-dict-tag :options="customDict.SexEnum" :value="record.sex"/>
        </span>
<!--        <span slot="isNotice" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_notice_status']" :value="record.isNotice"/>
        </span>-->
       <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status"/>
        </span>
        <span  slot="statusFlag" slot-scope="text, record">
          <a-switch @change="(checked) => onStatusChange(checked,record)" :checked-children="$t('正常')"
                    :un-checked-children="$t('禁用')" :checked="record.statusFlag"/>
        </span>
        <span  slot="hasBroadcastPermission" slot-scope="text, record">
          <a-switch @change="(checked) => onBroadcastPermissionChange(checked,record)" checked-children="有"
                    un-checked-children="无" :checked="record.hasBroadcastPermission === 1"/>
        </span>

        <template slot="avatar" slot-scope="text, record">
          <div>
            <img v-if="record.avatar" :src="record.avatar"  style="width:60px;height:62px;" @click="handleRecordPreview(record.avatar)" alt="none"/>
          </div>
          <br>
        </template>
        <template slot="userInfo" slot-scope="text, record">
          昵称：{{ record.nickName }} <br/>
          手机号：{{ record.mobile }} <br/>
          真实姓名：{{ record.realName }} <br/>
          生日：{{ record.birthday }} <br/>
          ID/邀请码：{{ record.invitationCode }} <br/>
          <template v-if="record.userRole === 70 && record.distributorAssistantName">
            <span>班长：{{ record.distributorAssistantName }} ({{ record.distributorAssistantMobile || '-' }})</span> <br/>
          </template>
          <br/>
        </template>
        <template slot="userMoneyInfo" slot-scope="text, record">
          可提现余额：{{ record.money }} <br/>
          平台充值余额：{{ record.rechargeMoney }} <br/>
<!--          充值金币：{{ record.recharge_gold }} <br/>-->
<!--          收入金币：{{ record.income_gold }} <br/>-->
          用户积分：{{ record.userScore }} <br/>
          <br/>
        </template>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
         <a @click="myTeam(record)">查看我邀请的人</a>
         <br/>
         <a v-if="record.userRole !== 60 && record.userRole !== 70" @click="handleSetDistributorAssistant(record)">{{$t('设置为班长')}}</a>
         <a v-if="record.userRole === 60" @click="handleCancelDistributorAssistant(record)">{{$t('取消班长')}}</a>
         <br/>
         <a v-if="record.userRole !== 60" @click="handleSetDistributor(record)">{{$t('设置/修改班长')}}</a>
          <br/>
         <a v-if="record.userRole === 70" @click="handleCancelDistributor(record)">{{$t('取消课代表')}}</a>
         <br/>
         <a v-if="record.userRole != 60 && record.userRole != 70" @click="handleSetSuperiorDistributor(record)">{{$t('设置上级课代表')}}</a>
        </span>

      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        :pageSizeOptions="pageSizeOptions"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
      <userExtension-modal ref="UserExtension" @ok="getList"></userExtension-modal>

      <!-- 设置班长弹窗 -->
      <a-modal :visible="distributorAssistantModalVisible" :title="$t('设置为班长')" @cancel="distributorAssistantModalVisible = false" @ok="confirmSetDistributorAssistant" :confirmLoading="modalLoading">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-item :label="$t('用户.昵称')">
            <span>{{ currentUser ? currentUser.nickName : '' }}</span>
          </a-form-item>
          <a-form-item :label="$t('企业微信链接')" :required="true" >
            <a-input v-model="distributorAssistantForm.customerServiceLink" :placeholder="$t('通用.输入.请输入')+$t('企业微信客服链接')" />
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 设置课代表弹窗 -->
      <a-modal :visible="distributorModalVisible" :title="$t('设置为课代表')" @cancel="distributorModalVisible = false" @ok="confirmSetDistributor" :confirmLoading="modalLoading">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-item :label="$t('用户.昵称')">
            <span>{{ currentUser ? currentUser.nickName : '' }}</span>
          </a-form-item>
          <a-form-item :label="$t('绑定班长')" :required="true">
            <a-select v-model="distributorForm.distributorAssistantId" :placeholder="$t('通用.输入.请选择')+$t('绑定班长')" show-search :filter-option="filterOption">
              <a-select-option v-for="item in distributorAssistantList" :key="item.id" :value="item.id">
                {{ item.nickName }} ({{ item.mobile }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 设置上级课代表弹窗 -->
      <a-modal :visible="superiorDistributorModalVisible" :title="$t('设置上级课代表')" @cancel="superiorDistributorModalVisible = false" @ok="confirmSetSuperiorDistributor" :confirmLoading="modalLoading">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-item :label="$t('用户.昵称')">
            <span>{{ currentUser ? currentUser.nickName : '' }}</span>
          </a-form-item>
          <a-form-item :label="$t('上级课代表')" :required="true">
            <a-select v-model="superiorDistributorForm.superiorDistributorId" :placeholder="$t('通用.输入.请选择')+$t('上级课代表')" show-search :filter-option="filterOption">
              <a-select-option v-for="item in distributorList" :key="item.id" :value="item.id">
                {{ item.nickName }} ({{ item.mobile }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 批量设置班长弹窗 -->
      <a-modal :visible="batchDistributorAssistantVisible" :title="'批量设置班长'" @cancel="batchDistributorAssistantVisible = false" @ok="confirmBatchSetDistributorAssistant" :confirmLoading="batchModalLoading">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-item label="已选用户">
            <a-tag v-for="id in selectedRowKeys" :key="id" style="margin: 2px">{{ id }}</a-tag>
          </a-form-item>
          <a-form-item label="企业微信链接" :required="true">
            <a-input v-model="batchDistributorAssistantForm.customerServiceLink" placeholder="请输入企业微信客服链接" />
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 批量设置上级课代表弹窗 -->
      <a-modal :visible="batchSuperiorDistributorVisible" :title="'批量设置上级课代表'" @cancel="batchSuperiorDistributorVisible = false" @ok="confirmBatchSetSuperiorDistributor" :confirmLoading="batchModalLoading">
        <a-form :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-item label="已选用户">
            <a-tag v-for="id in selectedRowKeys" :key="id" style="margin: 2px">{{ id }}</a-tag>
          </a-form-item>
          <a-form-item label="上级课代表" :required="true">
            <a-select v-model="batchSuperiorDistributorForm.superiorDistributorId" placeholder="请选择上级课代表" show-search :filter-option="filterOption">
              <a-select-option v-for="item in batchDistributorList" :key="item.id" :value="item.id">
                {{ item.nickName }} ({{ item.mobile }})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageUser, listUser, delUser, updateUserStatus, updateBroadcastPermission, setDistributorAssistant, cancelDistributorAssistant, setDistributor, cancelDistributor, getDistributorAssistantList, getDistributorList, setSuperiorDistributor} from '@/api/biz/user'
import CreateForm from './modules/CreateForm'
import UserExtensionModal from './modules/UserExtension'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import moment from 'moment';
import { tableMixin } from '@/store/table-mixin'
import {listLevel} from "@/api/user/level";
import {updateIsStudy} from "@/api/shop/shop";

export default {
  name: 'User',
  components: {
    CreateForm,
    UserExtensionModal,
    CustomDictTag
  },
  mixins: [tableMixin],
  data () {
    return {
      pageSizeOptions: ['10', '20', '50', '100'],
      list: [],
      levelList: [],

      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 注册时间区间
      dateRange: [],
      // 批量设置班长弹窗
      batchDistributorAssistantVisible: false,
      batchDistributorAssistantForm: {
        customerServiceLink: ''
      },
      batchModalLoading: false,
      // 批量设置上级课代表弹窗
      batchSuperiorDistributorVisible: false,
      batchSuperiorDistributorForm: {
        superiorDistributorId: undefined
      },
      batchDistributorList: [],
      // 班长弹窗
      distributorAssistantModalVisible: false,
      distributorAssistantForm: {
        customerServiceLink: ''
      },
      // 课代表弹窗
      distributorModalVisible: false,
      distributorForm: {
        distributorAssistantId: undefined
      },
      distributorAssistantList: [],
      currentUser: null,
      modalLoading: false,
      // 上级课代表弹窗
      superiorDistributorModalVisible: false,
      superiorDistributorForm: {
        superiorDistributorId: undefined
      },
      distributorList: [],
      // 查询参数
      queryParam: {
        mobile: null,
        email: null,
        nickName: null,
        sex: undefined,
        userRole: undefined,
        invitationCode: null,
        isNotice: null,
        status: undefined,
        createBeginTime: null,
        createEndTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: this.$t('用户.手机号'),
        //   dataIndex: 'mobile',
        //   align: 'center'
        // },
        // {
        //   title: this.$t('用户.昵称'),
        //   dataIndex: 'nickName',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '用户信息',
          dataIndex: 'userInfo',
          scopedSlots: { customRender: 'userInfo' },
          width: '240px',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.头像'),
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatar' },
          align: 'center'
        },
        {
          title: this.$t('用户.性别'),
          dataIndex: 'sex',
          scopedSlots: { customRender: 'sex' },
          align: 'center'
        },
       {
         title:  this.$t('用户.钱包'),
          dataIndex: 'userMoneyInfo',
          width: '200px',
          scopedSlots: { customRender: 'userMoneyInfo' },
          ellipsis: true,
          align: 'center'
        },
        {
          title:  this.$t('用户.角色类型'),
          dataIndex: 'userRole',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: 'userRole'},
        },
        {
          title: this.$t('用户.用户状态'),
          dataIndex: 'statusFlag',
          scopedSlots: { customRender: 'statusFlag' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '开播权限',
          dataIndex: 'hasBroadcastPermission',
          scopedSlots: { customRender: 'hasBroadcastPermission' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.解封时间'),
          dataIndex: 'unFrozenTime',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('用户.注册时间'),
          dataIndex: 'createTime',
          width: '150px',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getLevelList();
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    onStatusChange(statusFlag, record){
      let data = {id: record.id, statusFlag: statusFlag}
      updateUserStatus(data).then(response => {
        if (response.success) {
          this.$message.success(
            this.$t('通用.文本.修改成功'),
            3
          );
          this.$emit('ok')
          record.statusFlag = statusFlag
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    onBroadcastPermissionChange(hasPermission, record){
      let data = {userId: record.id, hasBroadcastPermission: hasPermission ? 1 : 0}
      updateBroadcastPermission(data).then(response => {
        if (response.success) {
          this.$message.success(
            '开播权限修改成功',
            3
          );
          record.hasBroadcastPermission = hasPermission ? 1 : 0
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    /** 查询用户信息列表 */
    getList () {
      this.loading = true
     pageUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    getLevelList () {
      listLevel().then(response => {
        this.levelList = response.data
      })
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    myTeam(record){
      console.log('查看我邀请的人');
      console.log(this.$refs.UserExtension);
      this.$refs.UserExtension.title="查看我邀请的人";
      this.$refs.UserExtension.team(record);
    },
    /** 设置班长按钮操作 */
    handleSetDistributorAssistant(record) {
      this.currentUser = record
      this.distributorAssistantForm.customerServiceLink = ''
      this.distributorAssistantModalVisible = true
    },
    /** 确认设置班长 */
    confirmSetDistributorAssistant() {
      if (!this.distributorAssistantForm.customerServiceLink) {
        this.$message.warning(this.$t('企业微信客服链接') + this.$t('通用.文本.不能为空'))
        return
      }
      this.modalLoading = true
      setDistributorAssistant({
        userId: this.currentUser.id,
        customerServiceLink: this.distributorAssistantForm.customerServiceLink
      }).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'))
          this.distributorAssistantModalVisible = false
          this.getList()
        } else {
          this.$message.error(response.message || '操作失败')
        }
      }).finally(() => {
        this.modalLoading = false
      })
    },
    /** 取消班长按钮操作 */
    handleCancelDistributorAssistant(record) {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.确认取消'),
        content: that.$t('确认取消该用户的班长角色吗？'),
        onOk() {
          cancelDistributorAssistant({ id: record.id }).then(response => {
            if (response.success) {
              that.$message.success(that.$t('通用.文本.取消成功'))
              that.getList()
            } else {
              that.$message.error(response.message || '操作失败')
            }
          })
        }
      })
    },
    /** 设置课代表按钮操作 */
    handleSetDistributor(record) {
      this.currentUser = record
      this.distributorForm.distributorAssistantId = undefined
      // 获取班长列表
      getDistributorAssistantList().then(response => {
        if (response.success) {
          this.distributorAssistantList = response.data || []
        }
      })
      this.distributorModalVisible = true
    },
    /** 确认设置课代表 */
    confirmSetDistributor() {
      if (!this.distributorForm.distributorAssistantId) {
        this.$message.warning(this.$t('绑定班长') + this.$t('通用.文本.不能为空'))
        return
      }
      this.modalLoading = true
      setDistributor({
        userId: this.currentUser.id,
        distributorAssistantId: this.distributorForm.distributorAssistantId
      }).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'))
          this.distributorModalVisible = false
          this.getList()
        } else {
          this.$message.error(response.message || '操作失败')
        }
      }).finally(() => {
        this.modalLoading = false
      })
    },
    /** 取消课代表按钮操作 */
    handleCancelDistributor(record) {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.确认取消'),
        content: that.$t('确认取消该用户的课代表角色吗？'),
        onOk() {
          cancelDistributor({ id: record.id }).then(response => {
            if (response.success) {
              that.$message.success(that.$t('通用.文本.取消成功'))
              that.getList()
            } else {
              that.$message.error(response.message || '操作失败')
            }
          })
        }
      })
    },
    /** 设置上级课代表按钮操作 */
    handleSetSuperiorDistributor(record) {
      this.currentUser = record
      this.superiorDistributorForm.superiorDistributorId = record.superiorDistributorId || undefined
      // 获取课代表列表
      getDistributorList(record.id).then(response => {
        if (response.success) {
          this.distributorList = response.data || []
        }
      })
      this.superiorDistributorModalVisible = true
    },
    /** 确认设置上级课代表 */
    confirmSetSuperiorDistributor() {
      if (!this.superiorDistributorForm.superiorDistributorId) {
        this.$message.warning(this.$t('上级课代表') + this.$t('通用.文本.不能为空'))
        return
      }
      this.modalLoading = true
      setSuperiorDistributor({
        userId: this.currentUser.id,
        superiorDistributorId: this.superiorDistributorForm.superiorDistributorId
      }).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'))
          this.superiorDistributorModalVisible = false
          this.getList()
        } else {
          this.$message.error(response.message || '操作失败')
        }
      }).finally(() => {
        this.modalLoading = false
      })
    },
    /** 班长搜索过滤 */
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    /** 注册时间区间变化 */
    onDateChange(dates) {
      if (dates && dates.length === 2) {
        this.queryParam.createBeginTime = dates[0]
        this.queryParam.createEndTime = dates[1]
      } else {
        this.queryParam.createBeginTime = undefined
        this.queryParam.createEndTime = undefined
      }
    },
    /** 批量设置班长按钮操作 */
    handleBatchSetDistributorAssistant() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择用户')
        return
      }
      this.batchDistributorAssistantForm.customerServiceLink = ''
      this.batchDistributorAssistantVisible = true
    },
    /** 确认批量设置班长 */
    confirmBatchSetDistributorAssistant() {
      if (!this.batchDistributorAssistantForm.customerServiceLink) {
        this.$message.warning('企业微信客服链接' + this.$t('通用.文本.不能为空'))
        return
      }
      this.batchModalLoading = true
      setDistributorAssistant({
        userIds: this.selectedRowKeys,
        customerServiceLink: this.batchDistributorAssistantForm.customerServiceLink
      }).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'))
          this.batchDistributorAssistantVisible = false
          this.onSelectChange([], [])
          this.getList()
        } else {
          this.$message.error(response.message || '操作失败')
        }
      }).finally(() => {
        this.batchModalLoading = false
      })
    },
    /** 批量设置上级课代表按钮操作 */
    handleBatchSetSuperiorDistributor() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请先选择用户')
        return
      }
      this.batchSuperiorDistributorForm.superiorDistributorId = undefined
      getDistributorList().then(response => {
        if (response.success) {
          this.batchDistributorList = response.data || []
        }
      })
      this.batchSuperiorDistributorVisible = true
    },
    /** 确认批量设置上级课代表 */
    confirmBatchSetSuperiorDistributor() {
      if (!this.batchSuperiorDistributorForm.superiorDistributorId) {
        this.$message.warning('上级课代表' + this.$t('通用.文本.不能为空'))
        return
      }
      this.batchModalLoading = true
      setSuperiorDistributor({
        userIds: this.selectedRowKeys,
        superiorDistributorId: this.batchSuperiorDistributorForm.superiorDistributorId
      }).then(response => {
        if (response.success) {
          this.$message.success(this.$t('通用.文本.操作成功'))
          this.batchSuperiorDistributorVisible = false
          this.onSelectChange([], [])
          this.getList()
        } else {
          this.$message.error(response.message || '操作失败')
        }
      }).finally(() => {
        this.batchModalLoading = false
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.dateRange = []
      this.queryParam = {
        mobile: undefined,
        email: undefined,
        nickName: undefined,
        sex: undefined,
        userRole: undefined,
        invitationCode: undefined,
        isNotice: undefined,
        status: undefined,
        createBeginTime: undefined,
        createEndTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('biz/user/export', {
            ...that.queryParam
          }, `用户信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    handleSelectExport () {
      var that = this
      let queryParam = {"idList": this.ids}
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出选中数据'),
        onOk () {
          that.download('biz/user/export', queryParam, `用户信息_${new Date().getTime()}.xlsx`)
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        },
        onCancel () {
          that.ids = []
          that.multiple = true;
          that.selectedRowKeys=[]
        }
      })
    }
  }
}
</script>
